import { useCallback } from 'react';
import { getApiUrl } from '../config';
import { Match, Player } from '../types';

interface UseTeamSynchronizationProps {
  matchId: string | undefined;
  onSetMatch: (match: Match) => void;
  onSetTeams: (teams: { team1: (Player | null)[]; team2: (Player | null)[] }) => void;
  buildTeamsFromMatch: (match: Match) => { team1: (Player | null)[]; team2: (Player | null)[] };
}

interface UseTeamSynchronizationReturn {
  syncTeamsWithBackend: () => Promise<void>;
}

export const useTeamSynchronization = ({
  matchId,
  onSetMatch,
  onSetTeams,
  buildTeamsFromMatch
}: UseTeamSynchronizationProps): UseTeamSynchronizationReturn => {
  // Función para sincronizar el estado local con el backend
  const syncTeamsWithBackend = useCallback(async () => {
    if (!matchId) return;

    try {
      const response = await fetch(getApiUrl(`/api/matches/${matchId}`));
      if (response.ok) {
        const data = await response.json();
        
        // Actualizar match Y equipos desde los datos del backend
        onSetMatch(data);
        if (data.lastTeams && data.lastTeams.team1 && data.lastTeams.team2) {
          const teams = buildTeamsFromMatch(data);
          onSetTeams(teams);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error syncing teams with backend:', error);
    }
  }, [matchId, buildTeamsFromMatch, onSetTeams]);

  return {
    syncTeamsWithBackend
  };
};
